import React, { createContext, useEffect, useState } from 'react';
import { Auth } from 'aws-amplify';

export const SubscriptionContext = createContext();

export const SubscriptionProvider = ({ children }) => {
  const [subscriptionStatus, setSubscriptionStatus] = useState(null); // null | active | expired | none
  const [loading, setLoading] = useState(true);

  const getToken = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const session = await Auth.currentSession();
      const jwt = session.getIdToken().getJwtToken();
      const username = user.username.includes("Google_")
        ? user.attributes.email
        : user.username;
      return [username, jwt];
    } catch {
      return [null, null];
    }
  };

  const fetchSubscription = async () => {
    try {
      setLoading(true); // Start loading whenever fetch is triggered
      const [username, jwt] = await getToken();
      // console.log("Username:", username);
      //   console.log("JWT:", jwt);
      if (!username || !jwt) return setSubscriptionStatus("none");

      const res = await fetch("https://api.quizwizard.net/quiz/getSubscription", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: jwt,
        },
        body: JSON.stringify({ username }),
      });

      const data = await res.json();
        // console.log("Recieved Data is : ",data);
        
      setSubscriptionStatus(data.status || "none");
    } catch (err) {
      setSubscriptionStatus("none");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscription();
  }, []);

  return (
    <SubscriptionContext.Provider value={{ subscriptionStatus, loading, refreshSubscription: fetchSubscription  }}>
      {children}
    </SubscriptionContext.Provider>
  );
};
